import React, {useState, useCallback, useEffect} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {clientDatesEditAction, clientDatesDelAction} from "../../../actions/clientAction";
import {Loader} from "../../../utils/loader/Loader";
import {InputProfile} from "../../../utils/input/InputProfile";
import {i_close} from "../../../icons";
import {ConfirmModal} from "../../../utils/confirm/ConfirmModal";

export function ClientDatesEditModal({clientId, course, trigger, handleComplete}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
    setErrors((errors) => {
      return {...errors, [name]: value.trim() === ''}
    });
  }, []);

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let errs = {};
    let values = {...form};
    if (values.start_at === '') {
      errs.start_at = true;
    }
    if (values.finish_at === '') {
      errs.finish_at = true;
    }
    if (course.start_at_part2 !== '') {
      if (values.start_at_part2 === '') {
        errs.start_at_part2 = true;
      }
      if (values.finish_at_part2 === '') {
        errs.finish_at_part2 = true;
      }
    } else {
      delete values['start_at_part2'];
      delete values['finish_at_part2'];
    }
    if (course.start_at_part3 !== '') {
      if (values.start_at_part3 === '') {
        errs.start_at_part3 = true;
      }
      if (values.finish_at_part3 === '') {
        errs.finish_at_part3 = true;
      }
    } else {
      delete values['start_at_part3'];
      delete values['finish_at_part3'];
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);

    dispatch(clientDatesEditAction(values)).then(() => {
      setLoading(false);
      setOpen(false);
      handleComplete(form);
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

    const handleDeleteStartAt = (period) => {
        if (loading) {
          return false;
        }
        
        let values = {...form};
        
        values.period = period
        
        dispatch(clientDatesDelAction(values)).then(() => {
          setLoading(false);
          setOpen(false);
          handleComplete(form);
        }).catch((e) => {
          setLoading(false);
          toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }

  useEffect(() => {
    if (open) {
      setForm({
        client_id: clientId,
        start_at: course.start_at || '',
        finish_at: course.finish_at || '',
        start_at_part2: course.start_at_part2 || '',
        finish_at_part2: course.finish_at_part2 || '',
        start_at_part3: course.start_at_part3 || '',
        finish_at_part3: course.finish_at_part3 || ''
      });
      setErrors({});
    }
  }, [open, clientId, course]);

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title">Изменение дат курса клиента</div>
      {!form && <Loader size="large" padded={true}/>}
      {form && <React.Fragment>
        <div className="modal__wrap">
          <div className="profile__wrap">
            <InputProfile type="date"
                          title="Дата старта"
                          name="start_at"
                          placeholder=""
                          value={form.start_at}
                          error={errors.start_at || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="date"
                          title="Дата окончания"
                          name="finish_at"
                          placeholder=""
                          value={form.finish_at}
                          error={errors.finish_at || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
                          
            <div className="del-start-at profile__group">
                <ConfirmModal trigger={<span className="pointer btn-delete">{i_close()}</span>} triggerWrap={false} title={"Удалить данный курс?"} handleOk={() => handleDeleteStartAt(1)}/>
            </div>
          </div>
          {course.start_at_part2 !== '' && <div className="profile__wrap">
            <InputProfile type="date"
                          title="Дата старта [part2]"
                          name="start_at_part2"
                          placeholder=""
                          value={form.start_at_part2}
                          error={errors.start_at_part2 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="date"
                          title="Дата окончания [part2]"
                          name="finish_at_part2"
                          placeholder=""
                          value={form.finish_at_part2}
                          error={errors.finish_at_part2 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
                          
            <div className="del-start-at profile__group">
                <ConfirmModal trigger={<span className="pointer btn-delete">{i_close()}</span>} triggerWrap={false} title={"Удалить данный курс?"} handleOk={() => handleDeleteStartAt(2)}/>
            </div>
          </div>}
          {course.start_at_part3 !== '' && <div className="profile__wrap">
            <InputProfile type="date"
                          title="Дата старта [part3]"
                          name="start_at_part3"
                          placeholder=""
                          value={form.start_at_part3}
                          error={errors.start_at_part3 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="date"
                          title="Дата окончания [part3]"
                          name="finish_at_part3"
                          placeholder=""
                          value={form.finish_at_part3}
                          error={errors.finish_at_part3 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
            <div className="del-start-at profile__group">
                <ConfirmModal trigger={<span className="pointer btn-delete">{i_close()}</span>} triggerWrap={false} title={"Удалить данный курс?"} handleOk={() => handleDeleteStartAt(3)}/>
            </div>
          </div>}
        </div>
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
      </React.Fragment>}
    </React.Fragment>
  </Modal>
};
